import { render, staticRenderFns } from "./audit_history_modal.vue?vue&type=template&id=2285b579&scoped=true"
import script from "./audit_history_modal.vue?vue&type=script&lang=js"
export * from "./audit_history_modal.vue?vue&type=script&lang=js"
import style0 from "./audit_history_modal.vue?vue&type=style&index=0&id=2285b579&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2285b579",
  null
  
)

export default component.exports